import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ML.css';
import predictiveImage from '../Assets/predictive.jpeg';
import automationImage from '../Assets/inelligent.jpeg';
import insightsImage from '../Assets/driven.jpeg';
import decisionImage from '../Assets/4.jpg';
import productOptimizationImage from '../Assets/product opt.jpg';
import innovativeProductizationImage from '../Assets/innov.jpg';

const ML = () => {
  useEffect(() => {
    // Observer for feature cards (animate on scroll)
    const cardElements = document.querySelectorAll('.feature-card.animate');
    const cardObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animated');
            setTimeout(() => {
              entry.target.classList.add('animation-complete');
            }, 1200); // Match animation duration
          }
        });
      },
      { threshold: 0.2 }
    );

    cardElements.forEach((element) => cardObserver.observe(element));

    // Immediately animate non-card elements on load
    const nonCardElements = document.querySelectorAll('.animate:not(.feature-card)');
    nonCardElements.forEach((element) => {
      element.classList.add('animated');
      setTimeout(() => {
        element.classList.add('animation-complete');
      }, 1200); // Match animation duration
    });

    return () => {
      cardElements.forEach((element) => cardObserver.unobserve(element));
    };
  }, []);

  const scrollToFeatures = () => {
    const featuresSection = document.querySelector('.features-section');
    if (featuresSection) {
      featuresSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="ai-ml-container">
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title animate">AI & ML Innovation</h1>
          <p className="hero-subtitle animate">
            Harnessing the power of Artificial Intelligence and Machine Learning to drive smarter solutions for a sustainable future.
          </p>
          <button
            className="cta-button animate"
            onClick={scrollToFeatures}
          >
            Explore Our Solutions
          </button>
        </div>
        <div className="hero-background"></div>
      </section>

      <section className="features-section">
        <h2 className="section-title animate">Why AI & ML?</h2>
        <div className="features-grid">
          <div className="feature-card animate">
            <img src={predictiveImage} alt="Predictive Analytics" className="feature-image" />
            <h3>Predictive Analytics</h3>
            <p>Leverage AI to forecast trends and optimize operations with precision.</p>
          </div>
          <div className="feature-card animate">
            <img src={automationImage} alt="Intelligent Automation" className="feature-image" />
            <h3>Intelligent Automation</h3>
            <p>Streamline processes with ML-driven automation for efficiency.</p>
          </div>
          <div className="feature-card animate">
            <img src={insightsImage} alt="Data-Driven Insights" className="feature-image" />
            <h3>Data-Driven Insights</h3>
            <p>Unlock actionable insights from complex datasets using advanced ML models.</p>
          </div>
          <div className="feature-card animate">
            <img src={decisionImage} alt="Real-Time Decision Making" className="feature-image" />
            <h3>Real-Time Decision</h3>
            <p>Empower your systems with AI for instant, informed decisions.</p>
          </div>
          <div className="feature-card animate">
            <img src={productOptimizationImage} alt="Product Optimization" className="feature-image" />
            <h3>Product Optimization</h3>
            <p>Enhance product performance and efficiency using AI-driven optimization techniques.</p>
          </div>
          <div className="feature-card animate">
            <img src={innovativeProductizationImage} alt="Innovative Productization" className="feature-image" />
            <h3>Innovative Productization</h3>
            <p>Transform ideas into market-ready solutions with ML-powered innovation.</p>
          </div>
        </div>
        <div className="particles">
          <span className="particle"></span>
          <span className="particle"></span>
          <span className="particle"></span>
          <span className="particle"></span>
        </div>
      </section>

      <section className="cta-section">
        <h2 className="cta-title animate">Ready to Transform Your Business?</h2>
        <p className="cta-text animate">
          Contact us to see how AI and ML can revolutionize your industry.
        </p>
        <Link to="/contact" className="cta-button animate">
          Get in Touch
        </Link>
      </section>
    </div>
  );
};

export default ML;